<template>
  <!-- Stand-in while the Superintresse panel's chunk (it drags in Adyen) is
       on its way. The sheet has no header of its own, so this is everything
       the user sees until the panel arrives. -->
  <div class="panel-loading">
    <Spinner :with-overlay="false" />
  </div>
</template>

<script>
import Spinner from '@/components/Loading/Spinner';

export default {
  name: 'SuperInterestPanelLoading',

  components: {
    Spinner
  }
};
</script>

<style lang="scss" scoped>
.panel-loading {
  // The spinner is absolutely positioned, so the stand-in has to carry the
  // height itself — otherwise the sheet slides up as an empty sliver.
  position: relative;
  width: 100%;
  min-height: 280px;

  @media ($desktop) {
    min-width: 480px;
    min-height: 360px;
  }
}
</style>
